// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"TAMgPWg1","contentWrapper":"F_LVmoZ7","skeletonLoaderWrapper":"AqQDL6i9","paginationLoaderWrapper":"HolwkEqZ"};